'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchingCustomerPrefs = exports.contactPrefs = exports.customerType = exports.hasOutstandingMTA = exports.policies = exports.fetching = exports.quotes = exports.customer = undefined;
var _reselect = require('reselect');
var _payOnAccount = require('../../pay-on-account');
var _payOnAccount2 = _interopRequireDefault(_payOnAccount);
var _constants = require('../constants');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var customer = exports.customer = function customer(state) {
  return state[_constants.NAME];
};
var quotes = exports.quotes = function quotes(state) {
  return customer(state).quotes;
};
var fetching = exports.fetching = function fetching(state) {
  return customer(state).fetching;
};
var policies = exports.policies = (0, _reselect.createSelector)(customer, function (customer) {
  return {
    live: customer.live,
    future: customer.future,
    history: customer.history
  };
});
var hasOutstandingMTA = exports.hasOutstandingMTA = (0, _reselect.createSelector)(customer, function (customer) {
  return customer.hasOutstandingMTA;
});
var customerType = exports.customerType = (0, _reselect.createSelector)(quotes, policies, _payOnAccount2.default, fetching, function (quotes, policies, pay, isFetching) {
  if (pay) {
    return 'broker-pay';
  }
  if (isFetching) {
    return 'loading';
  }
  if (quotes.length) {
    return 'quotes';
  }
  if (policies.live.length || policies.future.length || policies.history.length) {
    return 'policy';
  }
  if (quotes.length === 0) {
    return 'noquotes';
  }
  return undefined;
});
var contactPrefs = exports.contactPrefs = function contactPrefs(state) {
  return customer(state).contactPrefs;
};
var fetchingCustomerPrefs = exports.fetchingCustomerPrefs = function fetchingCustomerPrefs(state, formId) {
  return contactPrefs(state).fetching[formId];
};